var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElements(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.60547 14.605L8.60547 11.605M12.6055 9.60498L17.6055 6.60498M10.6055 3.60498V8.60498M10.6055 12.605V17.605M3.60547 6.60498L8.60547 9.60498M12.6055 11.605L17.6055 14.605",
    stroke: "white",
    strokeWidth: 1.21,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1055 7.60505V13.1051M12.1055 19.105L17.6055 16.105M3.10547 16.105L9.10547 19.105M2.10547 13.605V7.60505M3.10547 5.10504L9.10547 2.10504M18.1055 5.10504L12.1055 2.10504",
    stroke: "white",
    strokeWidth: 1.21,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.6055,
    cy: 2.10498,
    r: 1.5,
    stroke: "white",
    strokeWidth: 1.21,
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.6055,
    cy: 19.105,
    r: 1.5,
    stroke: "white",
    strokeWidth: 1.21,
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.10547,
    cy: 6.10504,
    r: 1.5,
    stroke: "white",
    strokeWidth: 1.21,
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.1055,
    cy: 6.10504,
    r: 1.5,
    stroke: "white",
    strokeWidth: 1.21,
    strokeLinejoin: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.1055,
    cy: 15.105,
    r: 1.5,
    stroke: "white",
    strokeWidth: 1.21,
    strokeLinejoin: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.10547,
    cy: 15.105,
    r: 1.5,
    stroke: "white",
    strokeWidth: 1.21,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6055 8.35504L12.6055 9.48004V11.73L10.6055 12.855L8.60547 11.73V9.48004L10.6055 8.35504Z",
    stroke: "white",
    strokeWidth: 1.21,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElements);
export default __webpack_public_path__ + "static/media/elements.8f4679421891fa706e47865a0b42dd47.svg";
export { ForwardRef as ReactComponent };